import React from "react";
import Drawer from '@mui/material/Drawer';
import Box from '@mui/material/Box';
import { useState, useTheme } from "react";
import IconButton from '@mui/material/IconButton';
import MenuIcon from '@mui/icons-material/Menu';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import { withRouter } from 'react-router-dom';
import { border } from "@mui/system";
import Typography from '@mui/material/Typography';
import { Scale } from "@mui/icons-material";



const MuiDrawer = (props) => {
    const [isDrawerOpen,setIsDrawerOpen] = useState(false);
    const { history } = props;
    const itemsList=[{text:"Home", onClick:()=> history.push('/')},
                     {text:"Our Story", onClick:()=> history.push('/story')},
                     {text:"FAQ's", onClick:()=> history.push('/faq')},
                     {text:"Invest Now", onClick:()=> history.push('/invest')},
                     {text:"Careers", onClick:()=> history.push('/career')},
                     {text:"Blog", onClick:()=> history.push('/blog')},
                     {text:"Contact", onClick:()=> history.push('/contact')},
                     
                    ];
    return (
        <> 
        <IconButton 
        size='large'
        color='inherit'
        aria-label="logo"
        
        onClick={() => setIsDrawerOpen(true)}
        sx={theme => ({ [theme.breakpoints.between('xs','sm')]:{ right:'20%',left:'80%'},
                        [theme.breakpoints.down('361')]:{marginLeft:39}
        
          })}
        
        >
          <MenuIcon  style={{backgroundColor:"white", position:"fixed",margin:'0.7em 0.5em 0.1em 0.7em', padding:"0.5em 0.5em 0.5em 0.9em",width:72,height:72}}  sx={theme => ({ [theme.breakpoints.between('xs','sm')]:{width:30,height:30},
                        [theme.breakpoints.up('sm')]:{width:40,height:40}})} />
            
        </IconButton>
    <Drawer anchor='right' open={isDrawerOpen} onClose={()=>setIsDrawerOpen(false)}>  
    <Box p={3}  width='260px' textAlign="right" ></Box> 
                
               
    
    <List sx={{marginTop:10}}>
       {itemsList.map((item, index) => {
           
           const {text,onClick}=item;
           
           return (
               <ListItem button key={text} onClick={onClick}>
                   <ListItemText  primary={<Typography style={{ fontFamily:'Lato', fontWeight: 600,fontSize:18 }}>
              {text}
            </Typography>} sx={{'&:hover': {
                    color: '#7D8B71'}, paddingLeft:10}} />
               </ListItem> 
           );
           })}
    </List> 
    
   </Drawer> 
   </>);
};
 
export default withRouter(MuiDrawer);